import { Injectable } from '@angular/core';
import { BcRestApi } from 'common/api/rest-api';
import { DynamicQueryDecoratorService } from 'common/dynamicquery/dynamic-query-decorator.service';
import { Chat } from 'common/xislivechat/models/chat';
import { DynamicQueryAdapterService } from 'common/dynamicquery/dynamic-query-adapter.service';
import { AssignmentHistoryModel } from 'shared/components/assignment-history/models/assignment-history.model';
import { DynamicQueryObservable } from 'common/dynamicquery/dynamic-query-observable.model';

@Injectable()
export class ChatsService {
  constructor(private DynamicQuery: DynamicQueryAdapterService,
              private DynamicQueryDecorator: DynamicQueryDecoratorService,
              private bcRestApi: BcRestApi) {
  }

  /**
   * Returns a decorated observable, connected to the chatByChatID Bold dynamic query what produces Chat models.
   * @description Decorated observable has inserted updated deleted functions.
   * @throws Error 'Missing chatId'
   * @param {String} chatId BoldChat Chat Id.
   * @returns {DynamicQueryObservable<Chat>} Produces Chat models.
   */
  observeChatByChatId(chatId): DynamicQueryObservable<Chat> {
    if (!chatId) {
      throw new Error('Missing chatId');
    }
    const chatObs = this.DynamicQuery.getQuery('chatByChatID', { ChatID: chatId });
    return this.DynamicQueryDecorator.create(chatObs, Chat.wrap);
  }

  /**
   * Answers a given chat in the BoldChat backend, assigning it to the logged in operator.
   * @param chat The chat object, instance of {xisLiveChat.models.Chat}
   * @returns {*} the response of the BoldChat Backend.
   */
  answerChat(chat) {
    return this.bcRestApi.answerChat(chat.ChatID);
  }

  /**
   * Ends a given chat in the BoldChat backend, marking it to be closed in a certain amount of time, and not
   * allowing any communication through that chat.
   * @param chatId The chat id
   * @returns {*} the response of the BoldChat Backend.
   */
  endChat(chatId) {
    return this.bcRestApi.endChat(chatId);
  }

  /**
   * Blocks the chat with the specified chatId.
   * @param chatId The chat id
   * @returns {*} the response of the BoldChat Backend.
   */
  blockChat(chatId: string) {
    return this.bcRestApi.blockChat(chatId);
  }

  public getAssignmentHistoryByChatId(chatId: string): Promise<AssignmentHistoryModel[]> {
    return this.bcRestApi.getAssignmentHistoryByChatId(chatId);
  }
}
